/* eslint-disable no-underscore-dangle */
import { Component, AfterViewInit, Input, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import { HisAuthService, HisBaseGlobalsService, HisGenericValueService, GenericValue, HisUiService, HisNotificationService } from 'hisng';

import { DYNAMIC_FIELD_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { DataDictionaryUtils } from 'app/fs/res/common/utils/data-dictionary-utils';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { Publication } from 'app/fs/res/publication/model/publication';
import { DynamicContentUtils } from 'app/fs/res/common/service/dynamic-content/dynamic-content-utils';
import { DocumentMetadata } from 'app/fs/res/common/model/documents/documentMetadata';
import { PublicationDocumentMetadata } from 'app/fs/res/publication/model/publication-document-metadata';

@Component( {
    selector: 'res-publication-edit-documents-data',
    templateUrl: './publication-edit-documents-data.component.html',
    providers: [ProviderManager.getComponentProvider(PublicationEditDocumentsDataComponent)],
} )
export class PublicationEditDocumentsDataComponent implements AfterViewInit {
    @Input() publication: Publication;
    @ViewChildren( DYNAMIC_FIELD_ANCHOR, { read: ViewContainerRef } ) fieldViewContainerList: QueryList<ViewContainerRef>;

    allCategories: GenericValue[];
    document: PublicationDocumentMetadata;
    private editIndexToRemember: number = null;
    public documentDialogVisibility = false;
    dateFormat: string;

    constructor(
        public auth: HisAuthService,
        public hisBaseGlobalsService: HisBaseGlobalsService,
        public dynamicContentUtils: DynamicContentUtils,
        private notificationService: HisNotificationService,
        private genericValueService: HisGenericValueService,
        private hisUiService: HisUiService) {
        this.genericValueService.getValueTypes( 'documentMetadataCategoryValue' ).subscribe( response => this.allCategories = response );
        this.dateFormat = this.hisUiService.translate('common.dateFormat');
    }

    ngAfterViewInit() {
        // trigger re-render count of ViewChildren dynamicFieldContainer
        this.fieldViewContainerList.changes.subscribe( (changes: any) => {
            // eslint-disable-next-line no-underscore-dangle
            if ( this.publication._dynamicComponent && this.hisBaseGlobalsService.isAnyModuleActive( 'HISINONERES' ) ) {
                // eslint-disable-next-line no-underscore-dangle
                this.publication._dynamicComponent = { ...this.publication._dynamicComponent };
            }
            console.log( 'fieldViewContainerList.toArray().length: ', this.fieldViewContainerList.toArray().length );
        } );
    }

    public isHidden( ddKey: string ) {
        return this.hisBaseGlobalsService.getDd(ddKey)?.hidden;
    }

    public isDocumentsPanelVisible() {
        let dDEntry = this.hisBaseGlobalsService.getDd('fs.res.publication.documents');
        return ( !dDEntry || !dDEntry.hidden )
            && this.hisBaseGlobalsService.isAnyModuleActive('HISINONERES')
            && this.auth.hasAny('RIGHT_FS_RES_PUBLICATION_CREATE_PUBLICATION_DOCUMENTS');
    }

    public category( documentMetadataCategoryId: number ): string {
        if ( !documentMetadataCategoryId || !this.allCategories) {
            return null;
        }

        const category = this.allCategories.find( ( c ) => c.id === documentMetadataCategoryId );

        return category?.defaulttext;
    }

    public addDocument() {
        this.document = new PublicationDocumentMetadata();
        if (this.publication.license) {
            this.document.license = this.publication.license;
        }
        this.editIndexToRemember = null;
        this.documentDialogVisibility = true;
    }

    public deleteDocument( index: number ) {
        this.publication.publicationDocuments.splice( index, 1 );
        this.publication.publicationDocuments.forEach( (d, i) => d.documents[0].sortorder = i + 1 );
    }

    public editDocument( document: PublicationDocumentMetadata, index: number ) {
        this.editIndexToRemember = index;
        this.document = JSON.parse( JSON.stringify( document ) );
        this.documentDialogVisibility = true;
    }

    public documentChange( event: PublicationDocumentMetadata ): void {
        if ( this.editIndexToRemember === null ) {
            if ( !this.publication.publicationDocuments ) {
                this.publication.publicationDocuments = [];
            }
            event.documents[0].sortorder = this.publication.publicationDocuments.length + 1;
            this.publication.publicationDocuments.push(event);
        } else {
            this.publication.publicationDocuments[this.editIndexToRemember] = event;
            this.editIndexToRemember = null;
        }
    }

    moveUp( document: PublicationDocumentMetadata ) {
        let newIndex = this.publication.publicationDocuments.findIndex( d => d.documents[0].sortorder === ( document.documents[0].sortorder - 1 ) );
        if ( newIndex >= 0 ) {
            document.documents[0].sortorder = document.documents[0].sortorder - 1;
            this.publication.publicationDocuments[newIndex].documents[0].sortorder = this.publication.publicationDocuments[newIndex].documents[0].sortorder + 1;
        }
        this.publication.publicationDocuments = this.publication.publicationDocuments.sort( ( a, b ) => a.documents[0].sortorder - b.documents[0].sortorder );
    }

    moveDown( document: PublicationDocumentMetadata ) {
        let newIndex = this.publication.publicationDocuments.findIndex( d => d.documents[0].sortorder === ( document.documents[0].sortorder + 1 ) );
        if ( newIndex > 0 && newIndex < this.publication.publicationDocuments.length ) {
            document.documents[0].sortorder = document.documents[0].sortorder + 1;
            this.publication.publicationDocuments[newIndex].documents[0].sortorder = this.publication.publicationDocuments[newIndex].documents[0].sortorder - 1;
        }
        this.publication.publicationDocuments = this.publication.publicationDocuments.sort( ( a, b ) => a.documents[0].sortorder - b.documents[0].sortorder );
    }
}
